
import { useState, useEffect } from 'react';
import { Transaction } from '@/types/transaction';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { fetchStripeAccountId } from '@/services/transactions/stripeAccountService';
import { fetchTransactions } from '@/services/transactions/transactionFetchService';

export function useTransactionDetails(id: string) {
  const [transaction, setTransaction] = useState<Transaction | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { toast } = useToast();

  useEffect(() => {
    const fetchTransaction = async () => {
      setLoading(true);
      setError(null);
      
      try {
        console.log('[Transaction Debug] Fetching transaction details for ID:', id);
        
        // Get the Stripe account ID
        const accountId = await fetchStripeAccountId();
        if (!accountId) {
          throw new Error('No Stripe account connected');
        }
        
        // Fetch transactions from the edge function
        const transactionsResponse = await fetchTransactions(accountId, 100);
        if (!transactionsResponse) {
          throw new Error('Failed to fetch transactions');
        }
        
        // Find the specific transaction by ID
        const foundTransaction = transactionsResponse.transactions.find(t => t.id === id);
        
        if (!foundTransaction) {
          throw new Error('Transaction not found');
        }
        
        setTransaction(foundTransaction);
      } catch (err: any) {
        console.error('[Transaction Debug] Error fetching transaction:', err);
        setError(err.message || 'Unable to load transaction details');
        
        toast({
          title: "Error",
          description: err.message || "Failed to load transaction details",
          variant: "destructive",
        });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTransaction();
    }
  }, [id, toast]);

  return {
    transaction,
    loading,
    error
  };
}